import { AllCountries, Country } from './Country';
/**
 * Normalizes free-text or legacy API country values to ISO-3166 alpha-3 codes
 * used in {@link Country} and beneficiary address dropdowns.
 */

export function normalizeCountryCodeForForm(input) {
  if (input == null || input === '') {
    return '';
  }

  var trimmed = String(input).trim();

  if (AllCountries.includes(trimmed)) {
    return trimmed;
  }

  var found = AllCountries.find(function (c) {
    return c === trimmed || c.toUpperCase() === trimmed.toUpperCase();
  });

  if (found) {
    return found;
  }

  var compact = trimmed.replace(/\s+/g, '').toUpperCase();
  var upper = trimmed.toUpperCase();
  var aliasToCountry = {
    // United Kingdom
    UK: Country.UnitedKingdomOfGreatBritainAndNorthernIreland,
    GB: Country.UnitedKingdomOfGreatBritainAndNorthernIreland,
    GBR: Country.UnitedKingdomOfGreatBritainAndNorthernIreland,
    UNITEDKINGDOM: Country.UnitedKingdomOfGreatBritainAndNorthernIreland,
    // Australia
    AU: Country.Australia,
    AUS: Country.Australia,
    // United States
    US: Country.UnitedStatesOfAmerica,
    USA: Country.UnitedStatesOfAmerica
  };

  if (aliasToCountry[compact] !== undefined) {
    return aliasToCountry[compact];
  }

  if (aliasToCountry[upper] !== undefined) {
    return aliasToCountry[upper];
  }

  return trimmed;
}